import React from 'react';
import {InputRow} from "../index";
import {Chip, Collapse, Paper, Tooltip} from "@material-ui/core";
import {ClearIcon} from "../../assets/images/images";
import {multiFileHandler, onChangeInput} from "../../services/utils";

export default function Index(props) {

  const {state, setState, id, label, maxSize, noOfFiles,accept} = props
  const {values} = state;
  const cancelHandler = (index) => {

    let newArray = (values[id] || []).filter((val, i) => index !== i)
    setState((pre) => ({
      ...pre,
      values: {
        ...pre.values,
        [id]: newArray
      }
    }))
  }

  return (

    <div className='mt-10'>
      <Tooltip title="Delete" arrow>
        <InputRow
          types={[
            {type: 'file', value: '', id, label, multiple: true, noOfFiles, maxSize,accept},
          ]}
          onChangeInput={(value, key) => {
            const files = multiFileHandler(values.filesList, value)
            onChangeInput(files, key, state, setState)
          }}
          numOfInputPerRow={1}
        />
      </Tooltip>
      <Collapse in={values[id].length} className='mt-10'>
        <Paper className='mt-20 p-20 display-flex flex-wrap'>
          {(values[id] || []).map((file, index) => {
            return (
              <div className='display-flex align-items-center mb-10 mr-10'>
                <Chip key={index} label={file?.name}/>
                <ClearIcon
                  style={{color: 'red', padding: 5}}
                  className='cursor-pointer'
                  onClick={e => {
                    cancelHandler(index)
                  }}/>
              </div>
            )
          })}
        </Paper>
      </Collapse>
    </div>
  );
}
